import React from "react";
import { NavLink } from "react-router-dom";

const CallerRemarksSidebar = () => {
  const isAdmin = localStorage.getItem("isAdmin") === "1";

  return (
    <div className="caller-sidebar">
      <h6 className="sidebar-title">Caller Panel</h6>

      <NavLink to="" end className="sidebar-link">
        <i className="bi bi-speedometer2"></i> Dashboard
      </NavLink>

       <NavLink to="assigned-cases" className="sidebar-link">
        <i className="bi bi-clipboard-check"></i> Assigned Cases
      </NavLink>

      {isAdmin && (
        <NavLink to="all-assigned-cases" className="sidebar-link">
          <i className="bi bi-clipboard2-data"></i> All Assigned Cases
        </NavLink>
      )}

      <NavLink to="remarks" className="sidebar-link">
        <i className="bi bi-journal-text"></i> Call Remarks
      </NavLink>

      <NavLink to="promise-to-pay" className="sidebar-link">
        <i className="bi bi-cash-stack"></i> Promise To Pay
      </NavLink>

      <NavLink to="caller-list" className="sidebar-link">
        <i className="bi bi-people"></i> Caller List
      </NavLink>

      <NavLink to="other-lsp-cases" className="sidebar-link">
        <i className="bi bi-folder2-open"></i> Other LSP Cases
      </NavLink>
    </div>
  );
};

export default CallerRemarksSidebar;
